const appConfig = {
  name: "IVIS Cloud Monitoring System (CMS)",
  version: "3.3.2",
  copyright: <> &copy; Reneon Technologies {new Date().getFullYear()}. All rights reserved </>,
};

export default appConfig;
